<ngx-loadable [module]="'featuretable'" [show]="true"></ngx-loadable>
